import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import CloseIcon from '@material-ui/icons/Close';

import './EventNarrativePanel.scss';

import { formatNumber, getAttributeText } from '../../Utilities/Helpers';
import { getCountyName } from '../../Utilities/Data';



export default function EventNarrativePanel({
  eventNarratives,
  hazardOptions,
  loc,
  setEventNarratives
}) {
  const [eventItems, setEventItems] = useState([]);
  

  useEffect(() => {
    (async () => {
      let eventArr = [];
      let {attrName} = getAttributeText(false, hazardOptions[1]);

      let county;
      if (loc.state) {
        county = loc.name;
      } else {
        let results = await getCountyName(eventNarratives[0].counties[0]);
        
        if (results === 'No county reported') {
          county = '';
        } else {
          county = results;
        }
      }

      if (county) {
        county += ' County,';
      }
      
      eventNarratives.forEach((event, index) => {
        let eventAmount;
        if (hazardOptions[1] === 'count') {
          eventAmount = <div>
            <div className="event-amount">Total Reported Crop Damage: <span>${formatNumber(event.damageCrops)}</span></div>
            <div className="event-amount">Total Reported Property Damage: <span>${formatNumber(event.damageProperty)}</span></div>
            <div className="event-amount">Total Reported Deaths: <span>{formatNumber(event.deathsDirect + event.deathsIndirect)}</span></div>
            <div className="event-amount">Total Reported Injuries: <span>{formatNumber(event.injuryDirect + event.injuryIndirect)}</span></div>
          </div>;
        } else {
          let amount = 0;
          if (hazardOptions[1] === 'injuries') {
            amount = event['injuryDirect'] + event['injuryIndirect'];
          } else if (hazardOptions[1] === 'deaths') {
            amount = event['deathsDirect'] + event['deathsIndirect'];
          } else {
            amount = event[hazardOptions[1]];
          }

          eventAmount = <div className="event-amount">{attrName}: <span>{hazardOptions[1].includes('damage') ? '$' : ''}{formatNumber(amount)}</span></div>;
        }
          
        let start, end;
        try {
          start = event.beginTime.slice(5,10);
          end = event.endTime.slice(5,10);
        } catch {
          start = 0;
          end = 0;
        }
      
        eventArr.push(
          <div key={event.event} className="event-narrative-container">
            <div className="event-header">
              {index === 0 ? <div className="event-title">{event.type} {start === end ? `on ${start}` : `from ${start} to ${end}`} in {county} {event.state}</div> : ''}
              <div className="event-id">Event ID: <span>{event.event}</span></div>
              {eventAmount}
            </div>
            <div className="event-narrative">{event.narrative || 'No narrative is available for this event.'}</div>
          </div>
        );
      });
    
      setEventItems(eventArr);
    })();
  }, [eventNarratives]);

  return (
    <div id="event-narratives-panel">
      {eventItems}
      <div className="close-btn"><CloseIcon onClick={() => setEventNarratives([])} /></div>
    </div>
  );
}

EventNarrativePanel.propTypes = {
  eventNarratives: PropTypes.array,
  hazardOptions: PropTypes.array,
  loc: PropTypes.object,
  setEventNarratives: PropTypes.func
};